import {DomainObject} from 'shared/store';
import {computed, observable} from 'mobx';

class AiScreenerCandidateResult extends DomainObject {
  @observable explanation;
  @observable rating;

  @computed get colour() {
    if (this.rating === null) {
      return 'waterloo';
    } else if (this.rating <= 3) {
      return 'scarlet';
    } else if (this.rating <= 6) {
      return 'sun';
    } else if (this.rating <= 10) {
      return 'grass';
    }

    return '';
  }

  @computed get ratingDisplay() {
    if (this.rating === null) {
      return 'Unknown';
    } else {
      return `${this.rating * 10}%`;
    }
  }
}

export default AiScreenerCandidateResult;
